import sanityClient from "@sanity/client";

export default sanityClient({
  projectId: "hm1a1q7u",
  dataset: "production",
});
